module.exports = __webpack_public_path__ + "static/media/blog-ads-vs-reco-user-segments.b53ecf99.png";